import { render, staticRenderFns } from "./CombatTrainingGame.vue?vue&type=template&id=50fe18be&scoped=true&"
import script from "./CombatTrainingGame.vue?vue&type=script&lang=js&"
export * from "./CombatTrainingGame.vue?vue&type=script&lang=js&"
import style0 from "./CombatTrainingGame.vue?vue&type=style&index=0&id=50fe18be&scoped=true&lang=scss&"
import style1 from "./CombatTrainingGame.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fe18be",
  null
  
)

export default component.exports